export function convertTime(time) {
    if (!time) {
        return null;
    }
    try {
        time = time.replace(' ', '');
        time = time.replace('am', 'AM');
        time = time.replace('pm', 'PM');
        let hours = Number(time.match(/^(\d+)/)[1]);
        const minutes = Number(time.match(/:(\d+)/)[1]);
        const AMPM = time.match(/(AM|PM)(.*)$/) ? time.match(/(AM|PM)(.*)$/)[1] : null;
        if (AMPM === 'PM' && hours < 12) {
            hours = hours + 12;
        }
        if (AMPM === 'AM' && hours === 12) {
            hours = hours - 12;
        }
        let sHours = hours.toString();
        let sMinutes = minutes.toString();
        if (hours < 10) {
            sHours = '0' + sHours;
        }
        if (minutes < 10) {
            sMinutes = '0' + sMinutes;
        }
        return sHours + ':' + sMinutes;
    } catch (e) {
        console.log(e);
        return time;
    }
}
